import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";

export const FormStatuses = ["idle", "loading", "submitted"];

export default {
  namespaced: true,
  state: {
    forms: []
  },
  actions,
  mutations,
  getters
};
